import type { ViewerPluginCreator } from './../ricos-types';

import { DEFAULTS } from './defaults';
import type { HashtagPluginViewerConfig } from './types';
import { HASHTAG_TYPE } from './types';
import { nodeViewDecorator } from './viewer/hashtagDecorator';

export const pluginHashtag: ViewerPluginCreator<HashtagPluginViewerConfig> = config => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: HASHTAG_TYPE,
    nodeViewDecorators: [nodeViewDecorator],
  };
};
